import api from '@/api';
import mapExampleData from "@/api/mapExampleData";

export default {
    namespaced: true,

    state: {
        autocompleteCollection: null,
        searchText: '',
        activeSearch: false
    },
    mutations: {
        setSearchText(state, text) {
            state.searchText = text;
        },

        toggleSearchPanel(state, value) {
            state.activeSearch = value
        }
    },
    actions: {
        async searchPlaceAutocomplete(context, searchText) {
            const lat = context.rootState.lat;
            const lng = context.rootState.lng;
            const sessionToken = context.rootState.sessionToken
                ? context.rootState.sessionToken
                : "";

            const cordinates = lat || lng ? `&lat=${lat}&lng=${lng}` : "";
            const url = `/api/v1/placesSearch?session_token=${sessionToken}&search=${encodeURIComponent(searchText)}${cordinates}`;

            const response = await api.request("get", url);
            context.commit("setSessionToken", response.data.session_token, {
                root: true
            });
            return response.data;
        },
        async searchAddressAutocomplete(context, {searchText, isGeocode, isAnon = false}) {
            const lat = context.rootState.lat;
            const lng = context.rootState.lng;
            const sessionToken = context.rootState.sessionToken
                ? context.rootState.sessionToken
                : "";

            const cordinates = lat || lng ? `&lat=${lat}&lng=${lng}` : "";
            const is_geocode = isGeocode ? '&is_geocode=true' : ''
            const url = `/api/v1/addressSearch${isAnon ? '/anon' : ''}?session_token=${sessionToken}&search=${encodeURIComponent(searchText)}${cordinates}${is_geocode}`;

            const response = await api.request("get", url, null, null, false, mapExampleData.getMapExampleAdditionHeaders(context));
            context.commit("setSessionToken", response.data.session_token, {
                root: true
            });
            return response.data;
        },
        async geocodeGooglePlaceId(context, {placeId, isAnon = false}) {
            const url = `/api/v1/geocodeGooglePlaceId${isAnon ? '/anon' : ''}?place_id=${encodeURIComponent(placeId)}`;
            const response = await api.request("get", url,null, null, false, mapExampleData.getMapExampleAdditionHeaders(context));
            return response.data;
        },
    },
};
